import { firebaseInit } from './firebase';
import '../../public/static/css/reset.css';
import '../../public/static/css/base.css';
import '../../public/static/css/common.css';
import '../../public/static/css/certification.css';
var goToWeb = function () {
    window.location.href = '/my';
};
var initialize = function () {
    firebaseInit();
    var btn = document.getElementById('id-btn');
    if (btn) {
        btn.addEventListener('click', goToWeb);
    }
};
initialize();
